angular.module('mtic.components.dashboards.teacher_general')
.directive('teacherStudents', function (
  $http,
  $log,
  $q,
  EventManager,
  language,
  userAccount,
  api,
  DATA_HOST,
  PanelFactory,
  PlatformService,
  TeacherDataService,
  $timeout,
  $rootScope)
{
  return {
    templateUrl: 'template.html',
    scope: {},
    link: function (scope, element) {

      var eventManager = new EventManager('teacherStudents', scope);
      var redirect_class = null;
      scope.isMobile = (navigator.userAgent.match(/Android/i) || /iPad|iPhone|iPod/.test(navigator.userAgent));

      scope.loadingStatus = {
          reset: function(){
            this.done = false;
            this.failed = false;
          },
          okay: function(){
            this.done = true;
            this.failed = false;
          },
          error: function(error){
            $log.error(error)
            this.done = true;
            this.failed = error || true;
          },
          done: false,
          failed: false,
      }

      scope.fullName = function(){
        return userAccount.getData().fullName
      }
      scope.userId = function(){
        return userAccount.getData().user_id
      }

      scope.flags = {
        accountsV2: false,
        accountsV1: false
      }
      $rootScope.sidebarExpanded = (PlatformService.isPhonePortrait() && window.location.href.indexOf('open_item_link') === -1  ? false : true);

      eventManager.listen('teacher:toggle:Sidepanel', function(e, val){
        $rootScope.sidebarExpanded = val;
      })
      scope.$watch('$root.sidebarExpanded', function(val){
        // $log.log('SIDEPANEL TOGGLED : ', val)
        TeacherDataService.sidepanelStatus = val;
        eventManager.broadcast('sidepanel:toggled', val);
      })

      eventManager.listen('teacher:selectClass', function(e, classroom) {
        scope.loadingStatus.reset();
        userAccount.setActiveClassFull(classroom);
        $q.all([
          PanelFactory.setupScopedMenuForStudentPanel(scope, classroom.id),
        ]).then(function(){
          scope.loadingStatus.okay()
        }).catch(function(error){
          scope.loadingStatus.error(error)
        })
      });

      scope.selectClass = function(){
        language.resetAvilableOptions();
        eventManager.broadcast('teacher:selectClass', scope.selectedClass);
//        console.log("triggered select class: ", scope.selectedClass)
      }

      scope.$watch('selectedClass', function(val){
        if(val){
          scope.selectClass();
        }
      })

      scope.$watch('nav.selection', function(val){
        if(val){
          $rootScope.pageNav = val + '-nav';
          if(PlatformService.isPhonePortrait()){
            $rootScope.sidebarExpanded = false;
          }
        }
      });

      var betaTabs = ['agenda', 'workspace'];

      var optionIdToTransId = {
        'studentsAddRemove': 'studentsAddRemove',
        'dashboard': 14566,
        'agenda': 14567,
        'workspace': 14568,
        'modules': 14569,
        'docs': 14570,
        'share-class': 14586,
        'class-leaderboard': 29373
      }

      scope.getTranslation = function(option_id){
//        console.log('[[TEACHER TAB IDs]]', option_id)
        var translationId = optionIdToTransId[option_id];
        if (translationId){
          return language.get(translationId);
        }
        else{
          return '';
        }
      }

      scope.getProperTranslation = function(id) {
        return language.get(id);
      }

      scope.isHiddenTab = function(option_id){
        return false && option_id === 'class-leaderboard';
      }

      scope.isBetaTab = function(option){
        if ( _.indexOf(betaTabs, option.id) !== -1 ){
          return true;
        }
        return false
      }

      scope.showPortraitModeWarning = true;
      scope.hidePortraidModeWarning = function() {
        scope.showPortraitModeWarning = false;
      }


      scope.getSidebarIcon = function(tabSlug){
        return 'assets/images/navbar/'+tabSlug+'.png';
      }

      function list_compare(item, list){
        var found = false;
        list.forEach( (this_class)=>{
          if(this_class.id === item.id){
            found = true;
          }
        })
        return found;
      }

      // PanelFactory.setupScopedMenu(scope, [
      //   {id: 'dashboard', name: 'Dashboard'},
      //   // {id: 'agenda', name: 'Agenda'},
      //   // {id: 'reports', name: 'Reports'},
      //   {id: 'workspace', name: 'Workspace'},
      //   // {id: 'items', name: 'Item View'},
      //   {id: 'accounts', name: 'Accounts', disable: !scope.showAccountsTab }
      // ]);

      TeacherDataService.getUserClasses(true)
      .then(function(classes){
        scope.classes = classes;
        scope.selectedClass = scope.classes[0];
        if (TeacherDataService.activeClassroomId){
          _.each(scope.classes, function(classroom){
            if (classroom.id === TeacherDataService.activeClassroomId){
              scope.selectedClass = classroom;
            }
          })
        }
        // $log.log('[[scope.selectedClass]]', scope.selectedClass);
        eventManager.broadcast('teacher:selectClass', scope.selectedClass)

        TeacherDataService.getModuleListFlat(scope.selectedClass.id)

        //Added this to prepend the type name
        TeacherDataService.getSchoolClasses(true, TeacherDataService.activeSchoolId, false)
        .then( function(classes) {
          //filtering out archived classes
          scope.classes = scope.classes.filter( (cur_class)=>{
            return list_compare(cur_class, classes)
          })
          scope.classes.forEach( function(cur_class){

            //auto redirect

            if(redirect_class && cur_class.id === redirect_class){
              $timeout(function(){
                //console.log('redirect class from list : ', redirect_class)
                scope.selectedClass = cur_class;
                scope.nav.setSelection('modules')
              }, 1000)
            }



               if(TeacherDataService.getUserSchools().$$state.value.length > 1){
                var school_name = '';
                TeacherDataService.getUserSchools().$$state.value.forEach( function(school){
                  if(school.id === TeacherDataService.activeSchoolId){
                    school_name = school.name;
                  }
                })
                if(school_name !== ''){
                  cur_class.fullname = cur_class.getType() ? school_name + ' - ' + cur_class.getType() + ' - ' + cur_class.name : school_name + ' - ' + cur_class.name;
                }else{
                  cur_class.fullname = cur_class.getType() ? cur_class.getType() + ' - ' + cur_class.name : cur_class.name;
                }
              }else{
                cur_class.fullname = cur_class.name;
              }
          })

          scope.classes = scope.classes.sort(function(a,b){
            return a.fullname > b.fullname
          });

        })
      });

      eventManager.listen('dashboard:to:workspace', function(e, args){
       scope.nav.setSelection('workspace', null, args)
      //  var timer = PlatformService.isApp ? 1000 : 250;
      //  $timeout(function(){
      //   eventManager.broadcast('filters:to:workspace', args)
      //  }, timer)
      })

      eventManager.listen('agenda:to:dashboard', function(e, args){
        scope.nav.setSelection('dashboard')
        $timeout(function(){
          eventManager.broadcast('filters:to:dashboard', {perspective:'agenda', agendaFocus: args.agenda_unit_id})
       }, 250)
      })

      eventManager.listen('refresh:current:tab', function(e){
        scope.nav.resetSelection();
       })

      eventManager.listen('agenda_change_request_granted', function(e, option){
        // $log.log('agenda change reuqest granted: ', option);
        if(!scope.nav){
          return;
        }
        scope.nav.setSelection(option, true);
      });

      var option_set_from_request;
      eventManager.listen('set:nav:selection', function(e, option){
        if(!scope.nav){
          option_set_from_request = option;
          return;
        }
        scope.nav.setSelection(option);
      });

      scope.$watch('nav', function(newval, old){
        if(!old && newval && option_set_from_request){
          scope.nav.setSelection(option_set_from_request);
          option_set_from_request = null;
        }
      })

      eventManager.listen('goto-module-tab', function(e, args){
        redirect_class = parseFloat(args);
//        console.log('redirect class : ', redirect_class)
      })



    }
  }
});
